import type { HasId } from "../../../lib/core/util/id"

type HasFromTo<T> = {
  from: T
  to: T
}

export default function isHasFromToHasIdListSame(
  list1 : Array<HasFromTo<HasId>>,
  list2 : Array<HasFromTo<HasId>>
) : boolean {
  if (list1.length === list2.length) {
    // start from the end
    for (let i = list1.length - 1; i >= 0; i--) {
      if (list1[i].from.id !== list2[i].from.id || list1[i].to.id !== list2[i].to.id) {
        return false
      }
    }
    return true
  }
  return false
}